import { memo, useEffect } from "react";
import PurchasePageTitle from "../../components/PurchasePageTitle";
import PurchaseCouponSection from "../../components/PurchaseCouponSection";
import PaymentMethodSection from "../../components/PaymentMethodSection";
import BillingInformationSection from "../../components/BillingInformationSection";
import { PurchaseStepE } from "../../models/enums";
import usePurchases from "../../hooks/usePurchases";
import PurchaseAddonSection from "../../components/PurchaseAddonSection";
import PurchasePaymentDetails from "../../components/PurchasePaymentDetails";
import { useUser } from "../../../../../contexts/userContext/userContext";
import config from "config";
import { useContent } from "../../../../../contexts/contentContext/contentContext";
import useCouponCode from "../../hooks/useCouponCode";

const MAX_DISCOUNT = 100;

const AddonPurchase = memo(() => {
  const { setDefaultSelectedOption, fetchPlans, completedStep } =
    usePurchases();
  const { couponCode } = useCouponCode();
  const { getUserData } = useUser();
  const { getPath } = useContent();

  useEffect(() => {
    // Get periodType param from URL
    // and set it as default selected option
    // on page mount.
    setDefaultSelectedOption();

    // Get details about JM plans in order to show it in the OptionList component.
    fetchPlans();
  }, []);

  useEffect(() => {
    // Not allow su user to see addons page
    if (getUserData()?.subUserRole) {
      window.location.href = config!.baseurl + getPath() + "plans";
    }
  }, [getUserData()?.subUserRole]);

  return (
    <div>
      <PurchasePageTitle />
      {completedStep <= PurchaseStepE.FIRST_PURCHASE_METHOD_STEP ? (
        <>
          <PurchaseAddonSection />
          <PurchaseCouponSection />
          {couponCode?.discount === MAX_DISCOUNT ? null : (
            <PaymentMethodSection />
          )}
          {completedStep === PurchaseStepE.FIRST_PURCHASE_METHOD_STEP ? (
            <BillingInformationSection />
          ) : null}
        </>
      ) : (
        <PurchasePaymentDetails />
      )}
    </div>
  );
});

export default AddonPurchase;
